module.exports = __webpack_public_path__ + "img/image-team-members.236eccf4.jpg";